import request from '@/utils/request'
// 上传文件
export const uploadFile = data => {
  return request.post('/taxapi/tax/uploadFile', data)
}
// 新上传文件
export const uploadNewFile = data => {
  return request.post('/agentapi/common/uploadnewFile', data)
}

// 发送验证码
export const sendsmsCode = data => {
  return request.post('/taxapi/tax/sendsmsCode', data)
}

// 企业性质下拉列表
export const natureList = () => {
  return request.get('/agentapi/agent/natureList')
}

// 客户下拉框
export const companyList = () => {
  return request.get('/taxapi/tax/companyList')
}

